class FileUploadController {
    $onInit () {
        this.ngModel.$render = () => this.file = this.ngModel.$viewValue;
        this.type = this.type || 'Image';
    }

    onChange () {
        this.currentUrl = undefined;
        this.ngModel.$setViewValue(this.file);
    }

    isFile (file) {
        return (typeof file === 'object');
    }
}

FileUploadController.$inject = [];

export default FileUploadController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/controllers/fileUpload.input.controller.js